const { messageContent } = require('./messageContent');

export const customValidate = {
  methods: {
    addressCheck: function (address) {
      if (typeof address === 'undefined') return false;

      /* eslint-disable */
      return address.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    passwordPatternCheck: function (password) {
      return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[A-Za-z0-9]{12,40}$/.test(password);
    },
    numberOnly: function (number) {
      return /^[0-9]*$/.test(number);
    },
    hasSpecialCharacterInString: function (string) {
      return /\&|\<|\>|\'|\"/.test(string);
    },
    hasSpecialCharacterInObject: function (obj) {
      /* eslint-disable */
      for (const [key, value] of Object.entries(obj)) {
        if (/^(?=.*[&<>'"]).*$/.test(value)) {
          return true;
        }
      }
      return false;
    },
    hasSpecialCharacterInStringForLog: function (string) {
      return /^(?=.*[&<>]).*$/.test(string);
    },
    hasSymbolCharacterInString: function (string) {
      return /^([ぁ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ0-9０-９ 　\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)+$/mu.test(string);
    },
    maxlengthCheck: function (params) {
      if (!params.content) {
        return { status: true };
      }
      const message = `${params.target}の最大文字数は${params.maxlength}文字です。`;
      if (params.content.replace(/\n/g, "").length > params.maxlength) {
        return { status: false, message };
      } else {
        return { status: true };
      }
    },
    guidanceLengthCheck: function (content) {
      const params = {
        target: 'ガイダンス内容',
        maxlength: 200, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    charCheck: function (params) {
      if (!params.content) {
        return { status: true };
      }
      let ngChar = '';
      for ( let i = 0; i < params.content.length; i++) {
        let c = params.content.charCodeAt(i);
        if ((0xD800 <= c && c <= 0xDBFF) || (0xDC00 <= c && c <= 0xDFFF)) {
          ngChar = ngChar + params.content.substring(i, i + 1);
        }
      }
      if (ngChar) {
        const message = `${params.target}に音声合成に対応できない文字が含まれています。文章を編集して再度保存してください。(該当の文字：${ngChar})`;
        return { status: false, message };
      } else {
        return { status: true };
      }
    },
    // #3056 4Bコードチェック汎用版
    // param中に4Bコードが無ければ''（空文字)で復帰
    // 4Bコードがあれば抽出して文字列として復帰
    with4BCode: function (param) {
      if (!!!param) {
        return '';
      }
      let ngChar = '';
      for ( let i = 0; i < param.length; i++) {
        let c = param.charCodeAt(i);
        if ((0xD800 <= c && c <= 0xDBFF) || (0xDC00 <= c && c <= 0xDFFF)) {
          ngChar = ngChar + param.substring(i, i + 1);
        }
      }
      return ngChar;
    },
    guidanceCharCheck: function (content) {
      const params = {
        target: 'ガイダンス内容',
        content,
      };
      return this.charCheck(params);
    },
    settingNameLengthCheck: function (content) {
      const params = {
        target: '設定名称',
        maxlength: 20, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    incomingGroupNameLengthCheck: function (content) {
      const params = {
        target: '着信グループ名',
        maxlength: 20, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    emailLengthCheck: function (content) {
      const params = {
        target: 'メールアドレス',
        maxlength: 50, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    departmentNameLengthCheck: function (content) {
      const params = {
        target: '部署名',
        maxlength: 20, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    fullNameLengthCheck: function (content) {
      const params = {
        target: '氏名',
        maxlength: 20, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    memoLengthCheck: function (content) {
      const params = {
        target: 'メモ',
        maxlength: 1000, // 半角、ローマ字、漢字も１文字としてカウント
        content,
      };
      return this.maxlengthCheck(params);
    },
    companyIDLengthCheck: function (content) {
      const params = {
        target: '契約ID',
        maxlength: 6,
        content,
      };
      return this.maxlengthCheck(params);
    },
    // #3130 TrialUser Enable
    companyIDCheck: function (content) {
      if (!content.match(/^[0-9]{6}$/) && !content.match(/^tri[0-9]{6}$/)) {
        return {
          status: false,
          message: `契約IDの入力形式に誤りがあります。`,
        }
      } else {
        return { status: true };
      };
    },
    userIDCheck: function (content) {
      if (!content) {
        return {
          status: false,
          message: `メールアドレスを入力してください。`,
        };
      }
      if (!this.addressCheck(content)) {
        const message = `メールアドレスを入力してください。`;
        return { status: false, message };
      } else {
        return { status: true };
      }
    },
    fullnameUnderbarCheck: function (fullname, head = '氏名') {
      if (fullname && fullname.includes('_')) {
        return { status: false, message: `${head}は${messageContent.fullnameNotIncludeUndebar}`, };
      }
      return { status: true };
    },
    passwordCheck: function (content, target = 'パスワード') {
      if (!content) {
        return {
          status: false,
          message: `${target}を入力してください。`,
        };
      }
      if (!this.passwordPatternCheck(content)) {
        const message = `${target}は12文字〜40文字で、大文字アルファベット、小文字アルファベット、数字をすべて１つ以上含ませてください。`;
        return { status: false, message };
      } else {
        return { status: true };
      }
    },
    onlySpaceCheck: function (content, target) {
      if (content && content.trim() === '') {
        return {
          status: false,
          message: `${target}は${messageContent.onlySpaceError}`,
        }
      }
      return { status: true };
    },
    isPhoneNumber: function (phoneNumber) {
      return this.numberOnly(phoneNumber) && (phoneNumber.length == 10 || phoneNumber.length == 11);
    },
    hasSpecialCharacterInObjectInvoice: function (obj) {
      /* eslint-disable */
      for (const [key, value] of Object.entries(obj)) {
        if (/^(?=.*[&<>'"／]).*$/.test(value)) {
          return true;
        }
      }
      return false;
    },
  },
};
